<template>
  <div class="product-file">
    <div  class="item">
      <div class="item-in">
        <div class="top">
          <div class="top-left">
            <img :src="getIconType" alt="" />
            <toolTip :title="file.attachment_name" maxWidth="80%">
              <span>{{ file.attachment_name }}</span>
            </toolTip>
          </div>
          <div class="top-right">
            <span class="size">{{ getfilesize(file.attachment_size) }}</span>
            <span class="file-icon">
              <el-tooltip effect="dark" content="预览" placement="top" v-if="canPreview(file.type || file.attachment_type)">
                <i class="icon iconfont iconicon_visible btn-active" @click.stop="review"></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="下载" placement="top" >
                <i class="icon iconfont iconicon_download btn-active" @click.stop="download"></i>
              </el-tooltip>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    file: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    getIconType() {
      return this.getFileTypeUrl(this.file?.attachment_type)
    }
  },
  data() {
    return {}
  },
  methods: {
    review() {
      this.getOssUrl(this.file?.oss_attachment_name, (data) => {
        this.opendImgUrl(this.file?.attachment_type, data.sign_url)
      })
    },
    download() {
      const loading = this.$loading({
        lock: true,
        text: `【${this.file.attachment_name}】正在下载中...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.getOssUrl(this.file.oss_attachment_name, data => {
        this.fileDown(data.sign_url, this.file.attachment_name, count => {
          loading.close()
        })
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.product-file {
  width: 100%;

  .item {
    padding: 0 16px;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    background-color: rgba(32, 32, 32, 0.04);
    border-radius: 4px;
    &:hover {
      background-color: rgba(32, 32, 32, 0.08);
      .file-icon {
        display: flex;
      }
      .size {
        display: none;
      }
    }
    &:last-child .item-in {
      border: 0 none;
    }
  }
  .item-in {
    border-bottom: 1px solid rgba(26, 26, 26, 0.08);
    box-sizing: border-box;
    img {
      width: 18px;
      margin-right: 8px;
    }
  }

  .top {
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
  }
  .top-left {
    display: flex;
    align-items: center;
    width: 0;
    flex: 1;
    font-weight: 500;
    font-size: 14px;
    color: rgba(32,32,32,0.8);
    line-height: 20px;
    img {
      width: 32px;
    }
  }
  .top-right {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(26, 26, 26, 0.6);
    .file-icon {
      display: none;
      align-items: center;
      grid-gap: 8px;
    }
  }
}
</style>
